
import { post, get } from '../components/api'

export const getMembershipPrice =  (membershipId,start_date, code, requestWht) => {
  const data =  post('/memberships/get_membership_order_summary',  {
    id: membershipId, start_date,code, request_for_wht: requestWht
  })

  return data
}